import { attorneyFunctions } from "./attorney"
import { docsFunctions } from "./docs"
import { practicesFunctions } from "./practices"
import { hasPositiveUMAvailable, isReducedUMZeroByLiability } from "./misc"
import { checkIfLopIsRequired, isCasePI, isCaseType, isDateInThePast, isDateTodayOrInThePast, isStateOfPip, patientHasCompleteAddress } from "./script"
import { attorneyStatusesOptions, attorneyStatusUnattached, retrieveTransportaionsData, workerCompsATPPolicyStatusOptionsPayerTypes } from "./systemData"
import { numberOfPaymentsExceedsTheSettings, totalBalanceExceedsTheSettings } from "./verifications"
import { liabilityFunctions } from "./liability"

export function AttyTabColor(attorneys, liabilities, caseAdditional, activeCase) {
    let tabState = {
        dot: false,
        dot_color: null,
        background: null,
        // color: `var(--white)`,
        color: null,
        message: null,
        classColor: null
    }

    let primaryAttorney = null
    if (attorneys && attorneys.length > 0) {
        primaryAttorney = attorneys.find(item => item.is_managing_attorney)
    } else {
        if (attorneys && attorneys.constructor == Array) {
            primaryAttorney = null
        } else {
            primaryAttorney = attorneys
        }        
    }


    let primaryInsurance = null
    if (liabilities && liabilities.length > 0) {
        primaryInsurance = liabilities.find(item => item.is_primary_insurance)
    } else {
        primaryInsurance = liabilities
    }

    function noAttyOrNoPrimary() {
        let option = attorneyStatusUnattached()?.find(item => item.value == caseAdditional?.no_attorney_reason)

        if (option) {
            let arr = []
            tabState.classColor = 'bk_' + option.color?.split(' ').join('_')

            arr.push(option.label)
            tabState.dot = true
            tabState.dot_color = `var(--red)`

            if (arr && arr.length > 0) {
                let str = ''
                arr.forEach((item, index) => {
                    str = str + '<div>' + item + '</div>'                 
                })
                tabState.message = `<div>${str}</div>`
            }
        }
    }

    if (primaryAttorney) {
        if (primaryAttorney.status_id) {
            
            let option = attorneyStatusesOptions()?.find(item => item.value == primaryAttorney.status_id)
 
            if (option) {
                tabState.classColor = 'bk_' + option.color?.split(' ').join('_')
            }

            // IF Status IS NOT "Confirmed Signed" == 12 OR "Signed w LOR" == 11  AND Liability status IS Investigation (== 2) or Unknown (== 3)
            if (primaryAttorney.status_id !== 12 && primaryAttorney.status_id !== 11) {
                if (primaryInsurance?.liability_status == 2 || primaryInsurance?.liability_status == 3) {
                    tabState.dot = true
                    tabState.dot_color = `var(--red)`
                }
            }

            
        }  
        let arr = []
        
        // if patient represented is false and liability status is Investigation (== 2) or Unknown (== 3)
        if (primaryAttorney.patient_represented == 0 && (primaryInsurance?.liability_status == 2 || primaryInsurance?.liability_status == 3)) {
            arr.push(`Patient is not represented <br />and Liability is Investigated`)
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        }

        if (attorneyFunctions.primaryAttorneyRequiresHIPAA(primaryAttorney) && practicesFunctions.isAnyPracticeMissingDocument(activeCase?.procodocs_documents, activeCase?.practices, primaryAttorney?.id, docsFunctions.returnDocumentTypeID('HIPAA')?.id, primaryAttorney, 'HIPAA', activeCase)) {
            arr.push('HIPAA document is missing for at least one practice')
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        }

        if (checkIfLopIsRequired(primaryAttorney, activeCase) && practicesFunctions.isAnyPracticeMissingDocumentByUseFor(activeCase?.procodocs_documents, activeCase?.practices, primaryAttorney?.id, docsFunctions.returnDocumentTypeID('LOP')?.id, primaryAttorney, 'LOP', activeCase)) {
            arr.push('LOP document is missing for at least one practice')
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        }

        if (arr && arr.length > 0) {
            let str = ''
            arr.forEach((item, index) => {
                str = str + '<div>' + item + '</div>'                 
            })
            tabState.message = `<div>${str}</div>`
        }
    } else {
        noAttyOrNoPrimary()
        // if (!otherAttys.some(item => item.active)) {
        //     noAttyOrNoPrimary()
        // }
    }

    // if (attorneys && attorneys.length > 0) {
    //     let primaryAttorney = attorneys.find(item => item.is_managing_attorney)
    //     let primaryInsurance = liabilities.find(item => item.is_primary_insurance)

    //     if (primaryAttorney) {
    //         if (primaryAttorney.status_id) {
                
    //             let option = attorneyStatusesOptions()?.find(item => item.value == primaryAttorney.status_id)

    //             if (option) {
    //                 tabState.classColor = 'bk_' + option.color?.split(' ').join('_')
    //             }

    //             // IF Status IS NOT "Confirmed Signed" == 12 OR "Signed w LOR" == 11  AND Liability status IS Investigation  (== 2)
    //             if (primaryAttorney.status_id !== 12 && primaryAttorney.status_id !== 11) {
    //                 if (primaryInsurance?.liability_status == 2) {
    //                     tabState.dot = true
    //                     tabState.dot_color = `var(--red)`
    //                 }
    //             }

                
    //         }  
    //         let arr = []
          
    //         // if patient represented is false and liability status is Investigated (== 2 )
    //         if (primaryAttorney.patient_represented == 0 && primaryInsurance?.liability_status == 2) {
    //             arr.push(`Patient is not represented <br />and Liability is Investigated`)
    //             tabState.dot = true
    //             tabState.dot_color = `var(--red)`
    //         }

    //         if (arr && arr.length > 0) {
    //             let str = ''
    //             arr.forEach((item, index) => {
    //                 str = str + '<div>' + item + '</div>'                 
    //             })
    //             tabState.message = `<div>${str}</div>`
    //         }
    //     } else {
    //         if (!attorneys.some(item => item.active)) {
    //             noAttyOrNoPrimary()
    //         }
    //     }
    // } else {
    //     noAttyOrNoPrimary()
    // }

    return tabState
}

export function LiabilityTabColor(liabilities) {
    let tabState = {
        dot: false,
        dot_color: null,
        background: null,
        // color: `var(--white)`,
        color: null,
        message: null
    }

    let primaryInsurance = null
    if (liabilities && liabilities.length > 0) {
        primaryInsurance = liabilities.find(item => item.is_primary_insurance)
    } else {
        if (liabilities && liabilities.constructor == Array) {
            primaryInsurance = null
        } else {
            primaryInsurance = liabilities
        } 
    }

    if (primaryInsurance) {
        // let text = "Fields that are modifing the tab's style: "
        let arr = []    
        // green 
        if (primaryInsurance.verified && primaryInsurance.liability_status == 1) { 
            tabState.background = 'var(--green-verification)'
            tabState.color = `var(--text)`
        }
        // orange
        if (primaryInsurance.verified && primaryInsurance.liability_status == 2) { 
            arr.push('Liability status is Investigation')
            tabState.background = 'var(--orange1)'
        }
        // grey — Unknown (not Assumed / Denied / Investigation yet)
        if (primaryInsurance.verified && primaryInsurance.liability_status == 3) {
            arr.push('Liability status is Unknown')
            tabState.background = 'linear-gradient(0deg, var(--grey-transparent, rgba(128,128,128,0.18)) 0%, var(--grey-transparent, rgba(128,128,128,0.18)) 100%), var(--background)'
            tabState.color = `var(--text)`
        }
    
        if (!primaryInsurance.verified) {
            arr.push('Policy is not verified')
            tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)'
            tabState.color = `var(--dark-yellow)`
        }        
        // red
        if (primaryInsurance.liability_status == 0) {
            arr.push('Liability status is Denied')
            tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
            tabState.color = `var(--red)`
        }

        // dot new 
        if (!primaryInsurance.claim_number && !primaryInsurance.policy_number) {
            arr.push('Policy Number was not provided')           
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        }
        if (primaryInsurance.verified && !primaryInsurance.claim_number) {
            arr.push('Claim Number was not provided')
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        }
        if (primaryInsurance.litigating_responsibility) {
            arr.push('Policy has Litigating Responsability')
            tabState.dot = true
            tabState.dot_color = `var(--orange1)`
        }
        if (primaryInsurance.verified && !primaryInsurance.policy_limit_patient) {
            arr.push('Policy Limit was not provided')
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        }    
        

        if (arr && arr.length > 0) {
            let str = ''
            arr.forEach((item, index) => {
                str = str + '<div>' + item + '</div>'                 
            })
            tabState.message = `<div>${str}</div>`
        }
    }

    return tabState
}

export function MedPayTabColor(medpayArr, activeCase) {
    let tabState = {
        dot: false,
        dot_color: null,
        background: null,
        // color: `var(--white)`,
        color: null,
        message: null
    }
    let primaryInsurance = null

    if (medpayArr && medpayArr.length > 0) {
        primaryInsurance = medpayArr.find(item => item.is_primary_insurance)
    } else {
        if (medpayArr && medpayArr.constructor == Array) {
            primaryInsurance = null
        } else {
            primaryInsurance = medpayArr
        } 
    }

    if (primaryInsurance) {
        let arr = []          

        // green 
        if (primaryInsurance.mp_verified) { // probably not needed to include the exhausted, is covered by red bellow
            if (primaryInsurance.has_mp) {
                tabState.background = 'var(--green-verification)'
                tabState.color = `var(--text)`
            }            
        }
        if (isStateOfPip(primaryInsurance?.insurance_state)) {
            if (primaryInsurance.has_pip) {
                tabState.background = 'var(--green-verification)'
                tabState.color = `var(--text)`
            }
        }
        // if (primaryInsurance.mp_verified) { // probably not needed to include the exhausted, is covered by red bellow
        //     if (isStateOfPip(primaryInsurance?.insurance_state)) {
        //         if ((primaryInsurance.has_pip || primaryInsurance.has_mp)) {
        //             tabState.background = 'var(--green-verification)'
        //             tabState.color = `var(--text)`
        //         }
        //     } else {
        //         if (primaryInsurance.has_mp) {
        //             tabState.background = 'var(--green-verification)'
        //             tabState.color = `var(--text)`
        //         }
        //     }
            
        // }
        
        // yellow   
        if (primaryInsurance.has_mp &&!primaryInsurance.mp_verified) { // it is not verified but has policy number
            arr.push('MP - Policy is not verified')
            tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)'
            tabState.color = `var(--dark-yellow)`
        }         
        if (isStateOfPip(primaryInsurance?.insurance_state) && primaryInsurance.has_pip && !primaryInsurance.pip_verified) {
            arr.push('PIP - Policy is not verified')
            tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)'
            tabState.color = `var(--dark-yellow)`
        }
        // if (!primaryInsurance.mp_verified) { // it is not verified but has policy number
        //     arr.push('Policy is not verified')
        //     tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)'
        //     tabState.color = `var(--dark-yellow)`
        // }  
        if (// there is pip, is not exhausted and pip status is not billing ==3  or open ==2
            isStateOfPip(primaryInsurance?.insurance_state) && //check for PIP state also!!!
            primaryInsurance.has_pip && 
            !primaryInsurance.pip_exausted && 
            (primaryInsurance.pip_status != 3) && 
            (primaryInsurance.pip_status != 2) &&
            (primaryInsurance.pip_status != 9) ) 
        { 

            arr.push('PIP Status is NOT Open or Billing or Ready to Bill')
            tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)'
            tabState.color = `var(--dark-yellow)`
        }            
        if (// there is no pip or it's exhausted and there is mp, is not exhausted and mp status is not billing ==3  or open ==2
            !isStateOfPip(primaryInsurance?.insurance_state) && //check for PIP state also!!!
            ((primaryInsurance.has_pip && primaryInsurance.pip_exausted) || !primaryInsurance.has_pip) &&
            primaryInsurance.has_mp && 
            !primaryInsurance.mp_exausted && 
            (primaryInsurance.mp_status != 3) && 
            (primaryInsurance.mp_status != 2) &&
            (primaryInsurance.mp_status != 9) 
        ) {
            arr.push('MP Status is NOT Open or Billing or Ready to Bill')
            tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)'
            tabState.color = `var(--dark-yellow)`
        }
        
        // red
        if (isStateOfPip(primaryInsurance?.insurance_state)) {
            if (
                (primaryInsurance.has_pip == 0 && primaryInsurance.has_mp == 0) ||
                (primaryInsurance.pip_exausted && primaryInsurance.mp_exausted) ||
                (primaryInsurance.has_pip != 1 && (primaryInsurance.has_mp == 0 || primaryInsurance.mp_exausted))
                ) { 
                    arr.push('No MP/PIP or Exhausted')
                    tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
                    tabState.color = `var(--red)`
            }
        } else {
            if (
                primaryInsurance.has_mp == 0 ||
                primaryInsurance.mp_exausted
            ) {
                arr.push('No MP or Exhausted')
                tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
                tabState.color = `var(--red)`
            }
        }
        // if (
        //     (primaryInsurance.has_pip == 0 && primaryInsurance.has_mp == 0) ||
        //     (primaryInsurance.pip_exausted && primaryInsurance.mp_exausted) ||
        //     (primaryInsurance.has_pip != 1 && (primaryInsurance.has_mp == 0 || primaryInsurance.mp_exausted))
        //     ) { 
        //     arr.push('No MP/PIP or Exhausted')
        //     tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
        //     tabState.color = `var(--red)`
        // }

        // dot 
        if (primaryInsurance.driver_excluded) {
            arr.push('Driver Excluded')           
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        }
        if (!primaryInsurance.mp_claim_number && !primaryInsurance.policy_number) {
            arr.push('Policy Number was not provided')           
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        }
        if (primaryInsurance.mp_verified ) {  
            if (!primaryInsurance.mp_claim_number) {
                arr.push('Claim Number was not provided')
                tabState.dot = true
                tabState.dot_color = `var(--red)`
            }

            if (
                isStateOfPip(primaryInsurance?.insurance_state) && //check for PIP state also!!!
                primaryInsurance.has_pip == 1 && 
                !primaryInsurance.pip_exausted && 
                !primaryInsurance.pip_policy_limit) {
                arr.push('PIP Limit was not provided')
                tabState.dot = true
                tabState.dot_color = `var(--red)`
            }

            if (primaryInsurance.has_mp == 1 && !primaryInsurance.mp_exausted && !primaryInsurance.mp_policy_limit) {
                arr.push('MP Limit was not provided')
                tabState.dot = true
                tabState.dot_color = `var(--red)`
            }                
        } 

        if (arr && arr.length > 0) {
            let str = ''
            arr.forEach((item, index) => {
                str = str + '<div>' + item + '</div>'                 
            })
            tabState.message = `<div>${str}</div>`
        }
    }

    return tabState
}

export function UMTabColor(umArr, liability) {
    let tabState = {
        dot: false,
        dot_color: null,
        background: null,
        // color: `var(--white)`,
        color: null,
        message: null
    }

    const liabilities = Array.isArray(liability) ? liability : (liability ? [liability] : [])
    const rawPrimaryLiability = liabilities.find(item => item.is_primary_insurance) || null
    const validPrimaryLiability = liabilityFunctions.isLiabilityValid(liabilities, 'policy_limit_patient')

    let primaryInsurance = null
    if (umArr && umArr.length > 0) {
        primaryInsurance = umArr.find(item => item.is_um_primary_insurance)
    } else {
        if (umArr && umArr.constructor == Array) {
            primaryInsurance = null
        } else {
            primaryInsurance = umArr
        } 
    }
    
    if (primaryInsurance) {

        // check first if has_um == 0, if it is show only um erorr, if not show the rest

        let arr = []
        const isVerified = primaryInsurance.um_verified == 1 || primaryInsurance.um_verified === true
        const isReducedZeroByLiability = primaryInsurance.has_um != 0
            && primaryInsurance.um_type == 1
            && isReducedUMZeroByLiability(validPrimaryLiability, primaryInsurance)

         if (primaryInsurance.has_um == 0) {
            arr.push('Insurance has No UM')
            tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
            tabState.color = `var(--red)`
        } else {
            // green 
            if (isVerified && hasPositiveUMAvailable(validPrimaryLiability, primaryInsurance)) {                 
                tabState.background = 'var(--green1-transparent)'
                tabState.color = `var(--text)`
            }
            // yellow      
            if (!isVerified) {
                arr.push('Policy is not verified')
                tabState.background = 'linear-gradient(0deg, var(--orange1) 0%, var(--orange1) 100%), var(--background)'
                tabState.color = `var(--text)`
            }  
            // orange -- is split - this is from negotiations
            if (isVerified && primaryInsurance.um_neg_split) { 
                arr.push('Negotiation - Split is selected')
                tabState.background = 'var(--orange1)'
            }

            // red
            // if (primaryInsurance.has_um == 0) {
            //     arr.push('Insurance has No UM')
            //     tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
            //     tabState.color = `var(--red)`
            // }

            // dot 
            if (primaryInsurance.driver_excluded) {
                arr.push('Driver Excluded')           
                tabState.dot = true
                tabState.dot_color = `var(--red)`
            }
            if (!primaryInsurance.um_claim_number && !primaryInsurance.policy_number) {
                arr.push('Policy Number was not provided')           
                tabState.dot = true
                tabState.dot_color = `var(--red)`
            }
            if (primaryInsurance.um_verified && !primaryInsurance.um_claim_number) {   
                arr.push('Claim Number was not provided')           
                tabState.dot = true
                tabState.dot_color = `var(--red)`
            } 
            if (primaryInsurance.um_verified && !primaryInsurance.um_policy_limit_patient) {    
                arr.push('UM limit patient was not provided')           
                tabState.dot = true
                tabState.dot_color = `var(--red)`
            } 
            if (rawPrimaryLiability) {

                if (rawPrimaryLiability.ins_owner == 2) {
                    arr.push('Liability - Patient at fault - Passenger (Household member)')  
                    tabState.dot = true
                    tabState.dot_color = `var(--red)`
                }
                if (Number(rawPrimaryLiability.ins_owner) == 3) {
                    arr.push('Liability - Patient at fault - Passenger (Non-Household member)')  
                    tabState.dot = true
                    tabState.dot_color = `var(--red)`
                }
            }

            // red -- reduced UM availability is $0.00 because liability exceeds the UM limit
            if (isReducedZeroByLiability) {
                // arr.push('Reduced UM availability is $0.00 (liability exceeds UM limits)')
                tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
                tabState.color = `var(--red)`
            }
        }
        

        if (arr && arr.length > 0) {
            let str = ''
            arr.forEach((item, index) => {
                str = str + '<div>' + item + '</div>'                 
            })
            tabState.message = `<div>${str}</div>`
        }
    }
    // if (umArr && umArr.length > 0) {
    //     let primaryLiability = liability.find(item => item.is_primary_insurance)
    //     let primaryInsurance = umArr.find(item => item.is_primary_insurance)
        
    //     if (primaryInsurance) {                       
    //         let arr = []      
    //         // green 
    //         if (primaryInsurance.um_verified && (primaryInsurance.has_um == 1) && (primaryInsurance.um_type !== null)) {                 
    //             tabState.background = 'var(--green2)'
    //         }
    //         // yellow 
    //         if (!primaryInsurance.um_verified && primaryInsurance.policy_number) {
    //             arr.push('Policy is not verified')
    //             tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)'
    //             tabState.color = `var(--dark-yellow)`
    //         }   
    //         // orange -- is split - this is from negotiations
    //         if (primaryInsurance.um_neg_split) { 
    //             arr.push('Negotiation - Split is selected')
    //             tabState.background = 'var(--orange1)'
    //         }

    //         // red
    //         if (primaryInsurance.has_um == 0) {
    //             tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
    //             tabState.color = `var(--red)`
    //         }

    //         // dot 
    //         if (primaryInsurance.um_verified && !primaryInsurance.um_claim_number) {    
    //             arr.push('Claim Number was not provided')           
    //             tabState.dot = true
    //             tabState.dot_color = `var(--red)`
    //         } 
    //         if (primaryInsurance.um_verified && !primaryInsurance.um_amount) {     
    //             arr.push('UM amount was not provided')           
    //             tabState.dot = true
    //             tabState.dot_color = `var(--red)`
    //         } 
    //         if (primaryLiability) {
    //             if (primaryLiability.ins_owner == 2) {
    //                 arr.push('Liability - Patient at fault - Passenger (Household member)')  
    //                 tabState.dot = true
    //                 tabState.dot_color = `var(--red)`
    //             }
    //             if (Number(primaryLiability.ins_owner) == 3) {
    //                 arr.push('Liability - Patient at fault - Passenger (Non-Household member)')  
    //                 tabState.dot = true
    //                 tabState.dot_color = `var(--red)`
    //             }
    //         }

    //         if (arr && arr.length > 0) {
    //             let str = ''
    //             arr.forEach((item, index) => {
    //                 str = str + '<div>' + item + '</div>'                 
    //             })
    //             tabState.message = `<div>${str}</div>`
    //         }
    //     }
    // }

    return tabState
}

export function MajorMedColor(data, activeCase) {
    let tabState = {
        dot: false,
        dot_color: null,
        background: null,
        // color: `var(--white)`,
        color: null,
        message: null
    }

    let primaryInsurance = null 
    if (data && data.length > 0) {
        primaryInsurance = data.find(item => item.is_primary_insurance)
    } else {
        if (data && data.constructor == Array) {
            primaryInsurance = null
        } else {
            primaryInsurance = data
        }
    }

    const caseHiofSelected = activeCase?.case?.hiof_selected

    if (primaryInsurance) {
        let arr = []           
        
        // green            
        if (primaryInsurance.verified) { // Is Verified + Opt-in only for PI Cases TODO!!!!
            if (isCasePI(activeCase)) {
                if (caseHiofSelected == 1) {
                    tabState.background = 'var(--green-verification)'
                    tabState.color = `var(--text)`
                }
            } else {
                tabState.background = 'var(--green-verification)'
                tabState.color = `var(--text)`
            }                
        }
        // yellow 
        // if (!primaryInsurance.verified && primaryInsurance.policy_number) {
        //     arr.push('Policy is not verified')
        //     tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)'
        //     tabState.color = `var(--dark-yellow)`
        // }
        if (!primaryInsurance.verified) {
            arr.push('Policy is not verified')
            tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)'
            tabState.color = `var(--dark-yellow)`
        }
        // orange 
        if (isCasePI(activeCase) && primaryInsurance.verified && (caseHiofSelected == 0)) { // Is Verified + ( Opt-out only for PI Cases )TODO!!!!
            arr.push('HIOF - Patient Opt-Out')
            tabState.background = 'var(--orange1)'
        }

        
        // red
        if (isDateInThePast(primaryInsurance.end_date) || primaryInsurance.no_coverage || primaryInsurance.no_insurance) {   
            if (isDateInThePast(primaryInsurance.end_date)) {
                arr.push('Policy is expired') 
            }
            if (primaryInsurance.no_coverage) {
                arr.push('Policy has no Coverage') 
            }
            if (primaryInsurance.no_insurance) {
                arr.push('Policy has no Insurance') 
            }
                    
            tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
            tabState.color = `var(--red)`
        }


        // dot -- if it has cancel_date show a red dot
        if (!primaryInsurance.policy_number) {
            arr.push('Policy Number was not provided')           
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        }
        if (primaryInsurance.cancel_date) {
            arr.push('Policy has Cancel Date')    
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        } 

        if (arr && arr.length > 0) {
            let str = ''
            arr.forEach((item, index) => {
                str = str + '<div>' + item + '</div>'                 
            })
            tabState.message = `<div>${str}</div>`
        }
    }

    // if (data && data.length > 0) {
    //     let primaryInsurance = data.find(item => item.is_primary_insurance)
       
    //     if (primaryInsurance) {
    //         let arr = []           
            
    //         // green            
    //         if (primaryInsurance.verified) { // Is Verified + Opt-in only for PI Cases TODO!!!!
    //             if (isCasePI(activeCase)) {
    //                 if (primaryInsurance.hiof_selected  == 1) {
    //                     tabState.background = 'var(--green2)'
    //                 }
    //             } else {
    //                 tabState.background = 'var(--green2)'
    //             }                
    //         }
    //         // yellow 
    //         if (!primaryInsurance.verified && primaryInsurance.policy_number) {
    //             arr.push('Policy is not verified')
    //             tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)'
    //             tabState.color = `var(--dark-yellow)`
    //         }
    //         // orange 
    //         if (isCasePI(activeCase) && primaryInsurance.verified && (primaryInsurance.hiof_selected  == 0)) { // Is Verified + ( Opt-out only for PI Cases )TODO!!!!
    //             arr.push('HIOF - Patient Opt-Out')
    //             tabState.background = 'var(--orange1)'
    //         }

            
    //         // red
    //         if (isDateInThePast(primaryInsurance.end_date) || primaryInsurance.no_coverage || primaryInsurance.no_insurance) {   
    //             if (isDateInThePast(primaryInsurance.end_date)) {
    //                 arr.push('Policy is expired') 
    //             }
    //             if (primaryInsurance.no_coverage) {
    //                 arr.push('Policy has no Coverage') 
    //             }
    //             if (primaryInsurance.no_insurance) {
    //                 arr.push('Policy has no Insurance') 
    //             }
                        
    //             tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
    //             tabState.color = `var(--red)`
    //         }


    //         // dot -- if it has cancel_date show a red dot
    //         if (primaryInsurance.cancel_date) {
    //             arr.push('Policy has Cancel Date')    
    //             tabState.dot = true
    //             tabState.dot_color = `var(--red)`
    //         } 

    //         if (arr && arr.length > 0) {
    //             let str = ''
    //             arr.forEach((item, index) => {
    //                 str = str + '<div>' + item + '</div>'                 
    //             })
    //             tabState.message = `<div>${str}</div>`
    //         }
    //     }
    // }

    return tabState
}

export function CrimeVictimColor(data, liability) {
    let tabState = {
        dot: false,
        dot_color: null,
        background: null,
        // color: `var(--white)`,
        color: null,
        message: null
    }
    if (data) {
        let arr = []    
        let primaryInsurance = liability.find(item => item.is_primary_insurance)
        // dot 

        if (data.filled_by_patient) {
            if (!data.submitted || primaryInsurance?.hit_run || primaryInsurance?.dui) {
                if (!data.submitted) {
                    arr.push('Application not submitted') 
                }
                if (primaryInsurance?.hit_run) {
                    arr.push('Liability - Hit & Run') 
                }
                if (primaryInsurance?.dui) {
                    arr.push('Liability - DUI') 
                }
                tabState.dot = true
                tabState.dot_color = `var(--red)`
            } 
            if (data.submitted && (data.approved != null && data.approved == 0) && data.appealed) {           
                arr.push('Application is denied and appealed')
                tabState.dot = true
                tabState.dot_color = `var(--red)`
            } 
    
            // green 
            if (data.approved == 1) { 
                tabState.background = 'var(--green-verification)'
                tabState.color = `var(--text)`
            }
            // red
            if (data.approved == 0) { 
                arr.push('Aplication - is denied') 
                tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
                tabState.color = `var(--red)`
            }
            if (data.approved == 1 && data.exhausted == 1) { 
                arr.push('Aplication - is exhausted') 
                tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
                tabState.color = `var(--red)`
            }
        }
        

        if (arr && arr.length > 0) {
            let str = ''
            arr.forEach((item, index) => {
                str = str + '<div>' + item + '</div>'                 
            })
            tabState.message = `<div>${str}</div>`
        }
    }

    return tabState
}

export function WorkerCompColor(item, caseFolder) {
    let tabState = {
        dot: false,
        dot_color: null,
        background: null,
        // color: `var(--white)`,
        color: null,
        message: null
    }

    if (item) {
        let arr = []

        // green 
        if (item.insurance_carrier && item.claim_number) { 
            tabState.background = 'var(--green-verification)'
            tabState.color = `var(--text)`
        }
        if (item.insurance_carrier && item.attorney && item.board_claim_number) { 
            tabState.background = 'var(--green-verification)'
            tabState.color = `var(--text)`
        }
        // yellow             
        if (!item.insurance_carrier && (item.employer_name && item.employer_phone && item.employer_address)) { // Employer information (Name, Phone OR Address) present but no Insurance 
            arr.push('Insurance Information was not provided') 
            tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)'
            tabState.color = `var(--dark-yellow)`
        }

        if (!item.insurance_carrier && item.attorney) { // Attorney checkbox is checked but no Insurance 
            arr.push('WorkComp has Attorney') 
            tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)'
            tabState.color = `var(--dark-yellow)`
        }

        if (item.insurance_carrier && !item.claim_number) { // when insurance is present + No Claim #
            arr.push('Claim Number was not provided') 
            tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)'
            tabState.color = `var(--dark-yellow)`


            //add the dot here since its the same message?
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        }          


        //status color
        let option = workerCompsATPPolicyStatusOptionsPayerTypes()?.find(opt => opt.value == item.policy_status)
        if (option) {
            tabState.classColor = 'bk_' + option.color?.split(' ').join('_')
        }


        // #### dot --
        if (!item.insurance_carrier && (!item.employer_name || !item.employer_phone || !item.employer_address)) { // NO Ins NO Employer Info (name, phone OR address)
            arr.push('Policy has No Insurance and No Employer Info')    
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        }         

        // RED: Service Request Date + Status is NOT "Approved"
        if (item.worker_comp_departments && item.worker_comp_departments.length>0) {
            let text = null
            item.worker_comp_departments.forEach(department => {
                if (department.services && department.services.length>0) {
                    let hasReqDateAndStatus = department.services.find(service => service.request_date && service.status_id != 1) // "Approved" == 1 
                    if (hasReqDateAndStatus) {
                        text = 'Services has Request Date but status is not Approved'
                    }
                }
            })

            if (text) {
                arr.push(text)    
                tabState.dot = true
                tabState.dot_color = `var(--red)`
            }
        }
        
        //Service Auth Exp. Date is today or in the past
        if (item.worker_comp_departments && item.worker_comp_departments.length>0) {
            let text = null
            item.worker_comp_departments.forEach(department => {
                if (department.services && department.services.length>0) {
                    let hasAuthExpDateAndIsPast = department.services.find(service => service.auth_exp_date && isDateTodayOrInThePast(service.auth_exp_date)) // "Approved" == 1                 

                    if (hasAuthExpDateAndIsPast) {
                        text = 'Services Auth Exp. Date is today or in the past'
                    }
                }
            })

            if (text) {
                arr.push(text)    
                tabState.dot = true
                tabState.dot_color = `var(--red)`
            }
        }

        if (arr && arr.length > 0) {
            let str = ''
            arr.forEach((item, index) => {
                str = str + '<div>' + item + '</div>'                 
            })
            tabState.message = `<div>${str}</div>`
        }
        
    } 

    return tabState
}

export function LienColor(data) {
    let tabState = {
        dot: false,
        dot_color: null,
        background: null,
        color: `var(--white)`,
        message: null
    }
    if (data) {
        let arr = []
        // green 
        
        // yellow 
       
        // red
        if (!patientHasCompleteAddress(data?.contact_information)) {   // check all address, not just county! /// !data.contact_information || !data.contact_information.county
            
            arr.push('Patient Address is incomplete.') 
            tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
            tabState.color = `var(--red)`
        } 

        if (arr && arr.length > 0) {
            let str = ''
            arr.forEach((item, index) => {
                str = str + '<div>' + item + '</div>'                 
            })
            tabState.message = `<div>${str}</div>`
        }
    }

    return tabState
}

export function SelfPayColor(data, activeCase, practices) {
    let tabState = {
        dot: false,
        dot_color: null,
        background: null,
        color: `var(--white)`,
        message: null
    }
    if (data) {
        let arr = []
        // green 
        
        // yellow 

        //red
        // CC Expiration Date - date field, if expired 
        if (data.cc_expiry_date && isDateTodayOrInThePast(data.cc_expiry_date)) {
            arr.push('Credit Card date is expired')    
            tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
            tabState.color = `var(--red)`
        }
        // CC Inactive - checkbox is checked
        if (data.has_cc_active == 0 || data.has_cc_active == false) {
            arr.push('Credit card is inactive')    
            tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
            tabState.color = `var(--red)`
        }
        //Payment Plan -> Approval is required but to be approved it must have a payment plan!
        if (data.has_payment_plan && (totalBalanceExceedsTheSettings(data.total_balance) || numberOfPaymentsExceedsTheSettings(data.no_payments)) && !data.has_approved) {
            arr.push('Approval is required')    
            tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
            tabState.color = `var(--red)`
        }
        //End Date has passed && Total Current Balance > 0
        if (data.has_payment_plan && data.end_date && isDateTodayOrInThePast(data.end_date)) {

            if (practices && practices.length > 0) {
                let hasPayments = practices.some(item => item.balance > 0)

                if (hasPayments) {
                    arr.push('Payment is not complete')    
                    tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
                    tabState.color = `var(--red)`
                }
            }
            
        }

        // ##### DOT ##### 
        // CHUSA - Expiration Date - when expired the field has red border, RED DOT shows on the tab (needs to be well and has chusa checked also)
        if (isCaseType(activeCase) == 'WELL' && data.has_chusa && data.chusa_expiry_date && isDateTodayOrInThePast(data.chusa_expiry_date)) {
            arr.push('CHUSA date is expired')    
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        }

        

        // Inactive: credit card is checked as inactive RED DOT should show up on the tab.
        if (data.cc_inactive) {
            arr.push('No credit card on file')    
            tabState.dot = true
            tabState.dot_color = `var(--red)`
        }



        if (arr && arr.length > 0) {
            let str = ''
            arr.forEach((item, index) => {
                str = str + '<div>' + item + '</div>'                 
            })
            tabState.message = `<div>${str}</div>`
        }
    }

    return tabState
}

export function TransportationColor(data, patient, practices) {
    let tabState = {
        dot: false,
        dot_color: null,
        background: null,
        color: `var(--white)`,
        message: null
    }

    if (data) {
        let arr = []


        
        // green 
        
        // yellow 

        //orange

        if (practices && practices.length > 0) {
            let hasTransMedic = practices.find(item => item.practice_id == 8)
            if (hasTransMedic && hasTransMedic.balance) {
                arr.push(`TransMedic has a balance`)    
                // tabState.dot = true
                tabState.background = 'var(--orange1)'
            }
        }
        // If Funds Remaining is < 50 then the tab becomes orange.
        if (data.funds_remaining && data.funds_remaining < Number(retrieveTransportaionsData()?.minimum_funds_remaining)) {
            arr.push(`Remaining funds are below $${retrieveTransportaionsData()?.minimum_funds_remaining}`)    
            // tabState.dot = true
            tabState.background = 'var(--orange1)'
        }
        // calculate 1 round trip (avg_trip_amount*2) and show warnings for less than 2 and less than 1 trip available
        let average = data.avg_trip_amount
        // let average = 100
        if (data.funds_remaining && average) {

            let roundTrip1 = average*2
            let roundTrip2 = roundTrip1*2

            if (data.funds_remaining < roundTrip1) {
                arr.push(`There aren't enough funds to make a round trip.`)    
                // tabState.dot = true
                tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
                tabState.color = `var(--red)`
            } else if (data.funds_remaining < roundTrip2) {
                arr.push(`There aren't enough funds to make two round trips.`)    
                // tabState.dot = true
                tabState.background = 'var(--orange1)'
            }
        }
        

        //red
        if (patient?.contact_information && !patientHasCompleteAddress(patient?.contact_information)) {
            arr.push('Patient Address is incomplete.') 
            tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)'
            tabState.color = `var(--red)`
        }
        

        // ##### DOT #####       

        if (arr && arr.length > 0) {
            let str = ''
            arr.forEach((item, index) => {
                str = str + '<div>' + item + '</div>'                 
            })
            tabState.message = `<div>${str}</div>`
        }
    }

    return tabState
}

export function SOSColor(data, practices) {
    let tabState = {
        dot: false,
        dot_color: null,
        background: null,
        color: `var(--white)`,
        message: null
    }

    if (data) {
        let arr = []
        if (practices && practices.length > 0) {
            let hasSOS = practices.find(item => item.practice_id == 9)
            if (hasSOS && hasSOS.balance) {
                arr.push(`SOS has a balance`)    
                // tabState.dot = true
                tabState.background = 'var(--orange1)'
            } 
        }
    }

    return tabState
}